import React from 'react';
import PagePanel from './PagePanel';
import Link from './Link';

const CheckFiguresPage = props => (
  <PagePanel>
    <h3>Excel Check Figures Worksheet Available</h3>
    <p>To help you with grading student accounting case submissions, I have developed an Excel worksheet in which you enter certain key figures from each company’s Form 10-K. The Excel file will produce a list of check figures that will allow you to quickly check over student submissions.</p>
    <p>You can get this Excel Check Figures worksheet by filling out the form below.</p>
    <p>Also use the form below to sign up to be notified of <b>updates</b> to the Accounting Case Template (just enter your email address for updates).</p>
    <p>Once you submit your information, I will be in contact with you within a few days once I have verified your instructor status.</p>
    <p>Please rest assured that I will not share the information you provide; I need it simply to assure that the Excel Check Figures worksheet goes only to verified instructors.</p>
		<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSc_QHcMxDt7wirXIzcAvaYZj-HH5uA1W7CuCaj8jAlavzZE2Q/viewform?embedded=true" width="650" height="1500" frameborder="0" marginheight="0" marginwidth="0">Loading...</iframe>
  </PagePanel>
);

export default CheckFiguresPage ;



// WEBPACK FOOTER //
// ./src/components/CheckFiguresPage.js